export default __webpack_public_path__ + "static/media/logo2.fa7c31d5.png";